import { GetterTree } from "vuex";
import { AuthState } from "./types";
import { RootState } from "../../types";

export const getters: GetterTree<AuthState, RootState> = {
  isAuthenticated: state => {
    return state.status === "success" && !!state.token;
  },
  authStatus: ({ status }) => status
};
